import { c as _c } from "react/compiler-runtime";
import type { ApiCreateGroupDescription } from "@/generated/models/ApiCreateGroupDescription";
import GroupCreateNumericValue from "./common/GroupCreateNumericValue";
import type { CommonSelectItem } from "@/components/utils/select/CommonSelect";
import CommonTabs from "@/components/utils/select/tabs/CommonTabs";
import { ApiGroupTdhInclusionStrategy } from "@/generated/models/ApiGroupTdhInclusionStrategy";
export default function GroupCreateTDH(t0) {
  const $ = _c(27);
  const {
    tdh,
    setTDH
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [{
      label: "TDH + xTDH",
      value: ApiGroupTdhInclusionStrategy.Both,
      key: ApiGroupTdhInclusionStrategy.Both
    }, {
      label: "TDH",
      value: ApiGroupTdhInclusionStrategy.Tdh,
      key: ApiGroupTdhInclusionStrategy.Tdh
    }];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const modes = t1;
  const t2 = tdh.inclusion_strategy === ApiGroupTdhInclusionStrategy.Both ? "TDH + xTDH" : tdh.inclusion_strategy;
  let t3;
  if ($[1] !== t2) {
    t3 = <p className="tw-mb-0 tw-text-base sm:tw-text-lg tw-font-semibold tw-text-iron-50">{t2}</p>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = tdh.inclusion_strategy === ApiGroupTdhInclusionStrategy.Both ? "TDH + xTDH" : tdh.inclusion_strategy;
  let t5;
  if ($[3] !== t4) {
    t5 = <p className="tw-mt-1 tw-mb-0 tw-text-sm tw-font-normal tw-text-iron-300">Set the group's minimum{" "}{t4}{" "}requirement.</p>;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t3 || $[6] !== t5) {
    t6 = <div>{t3}{t5}</div>;
    $[5] = t3;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== setTDH || $[9] !== tdh) {
    t7 = strategy => setTDH({
      ...tdh,
      inclusion_strategy: strategy
    });
    $[8] = setTDH;
    $[9] = tdh;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t7 || $[12] !== tdh.inclusion_strategy) {
    t8 = <div><CommonTabs items={modes} activeItem={tdh.inclusion_strategy} setSelected={t7} fill={false} filterLabel="Group TDH Mode" /></div>;
    $[11] = t7;
    $[12] = tdh.inclusion_strategy;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t6 || $[15] !== t8) {
    t9 = <div className="tw-mb-4"><div className="tw-flex tw-items-center tw-justify-between tw-gap-x-4">{t6}{t8}</div></div>;
    $[14] = t6;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const t10 = `${tdh.inclusion_strategy === ApiGroupTdhInclusionStrategy.Both ? "TDH + xTDH" : tdh.inclusion_strategy} at least`;
  let t11;
  if ($[17] !== setTDH || $[18] !== tdh) {
    t11 = value => setTDH({
      ...tdh,
      min: value
    });
    $[17] = setTDH;
    $[18] = tdh;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t10 || $[21] !== t11 || $[22] !== tdh.min) {
    t12 = <GroupCreateNumericValue value={tdh.min} label={t10} labelId="floating_tdh" setValue={t11} />;
    $[20] = t10;
    $[21] = t11;
    $[22] = tdh.min;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t12 || $[25] !== t9) {
    t13 = <div className="tw-p-3 sm:tw-p-5 tw-bg-iron-950 tw-rounded-xl tw-shadow tw-border tw-border-solid tw-border-iron-800">{t9}{t12}</div>;
    $[24] = t12;
    $[25] = t9;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  return t13;
}